import { ISlPluginOptions } from ".";
import { delay } from "../../../utils";
import { AgoraRemoteUsers, FirebaseData, SignLanguageService } from "./sl";

export default class BoxManager {
  private player: any;
  private signService: SignLanguageService;
  private isInitialized: boolean;
  private mainSlId: string | null;
  private users: AgoraRemoteUsers[] | [];
  private firebaseData: FirebaseData | null;
  private videoTrack: any | null;

  constructor(player: any) {
    this.player = player;
    this.signService = new SignLanguageService();
    this.isInitialized = false;
    this.mainSlId = null;
    this.users = [];
    this.firebaseData = null;
    this.videoTrack = null;
  }

  private controllVideoTrack() {
    console.log("🔄 Aktualisierte Remote-User:", this.users);
    console.log("🔄 Aktualisierte Firebase-Daten:", this.firebaseData);
    if (!this.firebaseData || this.users.length <= 0) {
      return;
    }
    if (
      this.firebaseData.liveStream &&
      this.firebaseData.mainId &&
      this.users.length > 0
    ) {
      console.log("GO ON");
      if (this.firebaseData.mainId !== this.mainSlId || !this.mainSlId) {
        console.log("New Main is active!!");
        this.mainSlId = this.firebaseData.mainId;

        if (this.firebaseData.mainId) {
          const user = this.users.find(
            (obj) => obj.uid === this.firebaseData?.mainId
          );
          if (this.videoTrack) {
            this.videoTrack.stop();
            this.videoTrack = null;
          }

          const videoTrack = user?.videoTrack || user?._videoTrack;
          if (videoTrack) {
            console.log("🎥 Video-Track erfolgreich gefunden:", videoTrack);
            videoTrack.play("video-1");
            this.videoTrack = videoTrack;
          } else {
            console.warn("⚠ Kein Video-Track gefunden!");
          }
        } else {
          console.log("mainId ist null oder undefined!");
        }
      }
    }

    if (!this.firebaseData.liveStream && this.videoTrack) {
      console.log("NO LIVE");
      this.videoTrack.stop();
      this.videoTrack = null;
      this.mainSlId = null;
    }
    /*
    if(firebaseData.liveStream && firebaseData.mainId) {
      if(firebaseData.mainId !== this.mainSlId) {
        this.mainSlId = firebaseData.mainId;
        const user = this.users.find(obj => obj.uid === firebaseData.mainId);
        const videoTrack = user?.videoTrack || user?._videoTrack;
        if (videoTrack) {
          console.log("🎥 Video-Track erfolgreich gefunden:", videoTrack);
          console.log(videoTrack.stop)
          console.log(videoTrack.isPlaying)
          videoTrack.play("video-1");
        } else {
          console.warn("⚠ Kein Video-Track gefunden!");
        }
      }
    }
      */
  }

  // Methode, um das grüne Box-Element anzuzeigen oder zu zerstören
  public async showGreenBox(options: ISlPluginOptions) {
    const container = this.player.el();
    const existingBox = container?.querySelector("#video-1");

    console.log('options', options)

    // Falls die Box schon existiert, alles beenden!
    if (existingBox) {
      this.destroy();
      return;
    }

    // Agora initialisieren, falls noch nicht geschehen
    if (!this.isInitialized) {
      await this.signService.init(options);
      await this.signService.initSignFirebase(options.event.id);
      this.isInitialized = true;
      console.log("🔵 Initialisiere Agora...");
      this.signService.onRemoteUsersChanged((users) => {

        // TODO: hier auch übnerprüfen ob irgendjemand drin ist.
        // die lokalen daten werden nicht geupdatet wenn firebase nicht aktualisert wird
        // evtl hier lokal mit firebase abgleichen
        //   wenn die remote usern nicht mehr mit den firebase daten stimmen dann hier loakl korrigieren
        this.users = users;
        this.controllVideoTrack();
      });
      this.signService.onFirebaseChanged(async (firebaseData: FirebaseData) => {
        this.firebaseData = firebaseData;
        this.controllVideoTrack();
      });
    }
    const greenBox = document.createElement("div");
    greenBox.id = "video-1";
    greenBox.style.position = "absolute";
    greenBox.style.zIndex = "999";
    greenBox.style.backgroundImage =
      "url('https://avatars.githubusercontent.com/u/3379777?s=200&v=4')";
    greenBox.style.backgroundSize = "cover";
    greenBox.style.backgroundPosition = "center";
    greenBox.style.backgroundRepeat = "no-repeat";
    
    
    function updateGreenBox() {
      const player = document.querySelector(".video-js");
      if (!player) return;
    
      const playerHeight = player.clientHeight; // Höhe des Video-Players
      const maxBoxHeight = playerHeight / 2; // Maximale Höhe = Hälfte des Players
      const aspectRatio = 1; // Höhe ist 1.6x der Breite
    
      if (window.matchMedia("(max-width: 768px)").matches) {
        // Mobile: Box nimmt das obere Drittel des Bildschirms ein, aber max. 50% des Players
        const screenHeight = window.innerHeight;
        let boxHeight = screenHeight / 3; // 1/3 der Bildschirmhöhe
        boxHeight = Math.min(boxHeight, maxBoxHeight); // Begrenzung auf 50% des Players
        let boxWidth = boxHeight / aspectRatio; // Breite anhand des Seitenverhältnisses berechnen
    
        greenBox.style.top = "0";
        greenBox.style.left = "50%";
        greenBox.style.width = boxWidth + "px";
        greenBox.style.height = boxHeight + "px";
        greenBox.style.transform = "translateX(-50%)"; // Zentrieren
      } else {
        const maxWidth = 480; // Maximale Breite
        const minWidth = 400; // Minimale Breite
    
        let height = Math.min(window.innerWidth * 0.12 * aspectRatio, maxBoxHeight);
    
        let width = height / aspectRatio;
    
        if (width < minWidth) {
          width = minWidth;
          height = width * aspectRatio;
        }
    
        if (width > maxWidth) {
          width = maxWidth;
          height = width * aspectRatio;
        }
    
        if (height > maxBoxHeight) {
          height = maxBoxHeight;
          width = height / aspectRatio;
        }
    
        greenBox.style.top = "10px";
        greenBox.style.right = "10px";
        greenBox.style.left = "auto";
        greenBox.style.width = width + "px";
        greenBox.style.height = height + "px";
        greenBox.style.transform = "none";
      }
    }
    
    
    
    
    
    // Initiales Setzen der Styles
    updateGreenBox();
    
    // Event Listener für Größenänderungen des Fensters
    window.addEventListener("resize", updateGreenBox);
    
    container?.appendChild(greenBox);
    
    
  }

  // Methode zum Beenden von Agora und Entfernen der Box
  public async destroy() {
    console.log("🛑 Beende Agora und entferne Box...");
    await this.signService.leave(); // Verlässt Agora und unsubscribt alle Streams

    const container = this.player.el();
    const existingBox = container?.querySelector("#video-1");
    if (existingBox) {
      existingBox.remove();
      console.log("✅ Box wurde entfernt.");
    }
    this.isInitialized = false;
  }
}

/**!SECTION

 const user = users[0];
        const videoTrack = user?.videoTrack || user?._videoTrack;

        if (videoTrack) {
          console.log("🎥 Video-Track erfolgreich gefunden:", videoTrack);
          videoTrack.play("video-1");
        } else {
          console.warn("⚠ Kein Video-Track gefunden!");
        }

*/
